export default __webpack_public_path__ + "static/media/service-2.178fc8b3.png";